module.exports = __webpack_public_path__ + "app/principal/modals/modal-routing-code-2-G1eCG-.html";